import { Outlet } from "react-router-dom";

export default function ReportsLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
